import _ from 'lodash'
import ACCORDION_CONFIG from './config'

class AccordionClass {
    constructor( accordion ) {
        this.DOM = {
            accordion: accordion,
            blocks: Array.from( _.selectAll( '.c-accordion__block', accordion ) ),
            triggers: Array.from( _.selectAll( '.c-accordion__trigger', accordion ) )
        }

        this.collapse = this.DOM.accordion.getAttribute( 'data-accordion-collapse' )
        this.initial = this.DOM.accordion.getAttribute( 'data-accordion-initial' )
        this.init()
    }

    init() {
        this._listeners()
        this._initial()
    }

    _initial() {
        this.initial === 'true' ? this.DOM.triggers[0].click() : null
    }

    _listeners() {
        this.DOM.triggers.forEach( ( trigger ) => { trigger.addEventListener( 'click', this._trigger.bind( this ) ) })
    }

    _trigger() {
        let index = this.DOM.triggers.indexOf( event.currentTarget )
        this.collapse == 'true' ? this._hideAll( index ) : null
        _.containClass( this.DOM.blocks[ index ], 'is--active' ) ? _.removeClass( this.DOM.blocks[ index ], 'is--active' ) : _.addClass( this.DOM.blocks[ index ], 'is--active' )
    }

    _hideAll( index ) {
        this.DOM.blocks.forEach( ( block, key ) => {
            index != key ? _.removeClass( block, 'is--active' ) : null
        })
    }
}

const ACCORDIONS = []
ACCORDION_CONFIG.accordions.forEach( ( accordion ) => { ACCORDIONS.push( new AccordionClass( accordion ) ) })